var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlarmaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 22c-1.182 0-2.352-.233-3.444-.685-1.092-.452-2.084-1.115-2.92-1.951-.836-.836-1.499-1.828-1.95-2.92C3.232 15.352 3 14.182 3 13s.233-2.352.685-3.444c.452-1.092 1.115-2.084 1.951-2.92.836-.836 1.828-1.499 2.92-1.95C9.648 4.232 10.818 4 12 4c2.387 0 4.676.948 6.364 2.636C20.052 8.324 21 10.613 21 13s-.948 4.676-2.636 6.364C16.676 21.052 14.387 22 12 22zm0-2c.92 0 1.83-.181 2.679-.533.85-.352 1.62-.867 2.27-1.517.65-.65 1.166-1.422 1.518-2.271.352-.85.533-1.76.533-2.679 0-.92-.181-1.83-.533-2.679-.352-.849-.867-1.62-1.517-2.27-.65-.65-1.422-1.166-2.271-1.518C13.829 6.18 12.919 6 12 6c-1.856 0-3.637.738-4.95 2.05C5.738 9.363 5 11.144 5 13c0 1.857.738 3.637 2.05 4.95C8.363 19.263 10.144 20 12 20zm1-7h3v2h-5V8h2v5zM1.747 6.282l3.535-3.535 1.415 1.414L3.16 7.697 1.747 6.282zm16.97-3.535l3.536 3.535-1.414 1.415-3.536-3.536 1.415-1.414z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmaWhite);
export default __webpack_public_path__ + "static/media/Icon_alarma_white.6d8a46eb.svg";
export { ForwardRef as ReactComponent };